const en = {
    // Navigation
    'nav.overview': 'Overview',
    'nav.payslip': 'Payslip',
    'nav.calendar': 'Calendar',
    'nav.contact': 'Contact',
    'nav.profile': 'Profile',
    'nav.amercement': 'Amercement',
    'nav.rules': 'Rules',
    'nav.admin': 'Admin',
    'nav.attendance': 'Attendance',
    'nav.leave': 'Leave',
    'nav.overtime': 'Overtime',
    'nav.payroll': 'Payroll',
    'nav.setting': 'Setting',
    'nav.rulesEditor': 'Rules Editor',

    // Header
    'header.logout': 'Logout',
    'header.switchToEnglish': 'Switch to English',
    'header.switchToVietnamese': 'Switch to Vietnamese',

    // Language
    'language.english': 'English',
    'language.vietnamese': 'Tiếng Việt',

    // Calendar
    'calendar.upcomingEvents': 'Upcoming Events',
    'calendar.addNewEvent': 'Add New Event',
    'calendar.createEvent': 'new event',
    'calendar.category': 'Category',
    'calendar.title': 'Title',
    'calendar.start': 'Start',
    'calendar.end': 'End',
    'calendar.dayOff': 'Day Off',
    'calendar.companyEvent': 'Company Event',
    'calendar.paidHoliday': 'Paid Holiday',
    'calendar.weekend': 'Weekend',
    'calendar.holiday': 'Holiday',
    'calendar.event': 'Event',
    'calendar.meeting': 'Meeting',
    'calendar.birthday': 'Birthday',
    'calendar.teamBuilding': 'Team Building',
    'calendar.partyDay': 'Party Time',
    'calendar.chillingDay': 'Chilling Day',
    'calendar.happyHoliday': 'Happy Holiday',
    'calendar.happyBirthday': 'Happy Birthday',
    'calendar.eventDefault': 'Event',

    // Common
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.update': 'Update',
    'common.search': 'Search',
    'common.export': 'Export',
    'common.approve': 'Approve',
    'common.reject': 'Reject',
    'common.loading': 'Loading...',
    'common.actions': 'Actions',
    'common.delete': 'Delete',
    'common.add': 'Add',
    'common.edit': 'Edit',
    'common.no': 'No.',
    'common.name': 'Full Name',
    'common.email': 'Email',
    'common.month': 'Month',
    'common.year': 'Year',
    'common.status': 'Status',
    'common.note': 'Note',
    'common.from': 'From',
    'common.to': 'To',
    'common.date': 'Date',
    'common.type': 'Type',
    'common.reason': 'Reason',
    'common.total': 'Total',
    'common.detail': 'Detail',
    'common.back': 'Back',
    'common.confirm': 'Confirm',
    'common.success': 'Success',
    'common.error': 'Error',
    'common.warning': 'Warning',
    'common.info': 'Info',
    'common.min': 'min',

    // Admin Rules Editor
    'adminRuleEditor.title': 'Rules',

    // Admin Setting
    'adminSetting.title': 'Settings',
    'adminSetting.allowedIPs': 'Allowed IP List',
    'adminSetting.addIP': 'Add IP',
    'adminSetting.workingRules': 'Working Rules',
    'adminSetting.ipAddress': 'IP Address',

    // Profile
    'profile.title': 'My Profile',
    'profile.fullName': 'Full Name',
    'profile.email': 'Email',
    'profile.role': 'Role',
    'profile.cccd': 'CCCD',
    'profile.phone': 'Phone No',
    'profile.birthday': 'Birthday',
    'profile.gender': 'Gender',
    'profile.male': 'Male',
    'profile.female': 'Female',
    'profile.address': 'Address',
    'profile.dateOfJoining': 'Date Of Joining',
    'profile.bankAccount': 'Bank Account',
    'profile.bankName': 'Bank Name',
    'profile.updateProfile': 'Update Profile',

    // Payslip
    'payslip.title': 'Payslip',
    'payslip.salary': 'Salary',
    'payslip.workingDays': 'Working Days',
    'payslip.totalWorkingDays': 'Total Working Days',
    'payslip.paidWorkingDays': 'Paid Working Days',
    'payslip.paidLeave': 'Paid Leave',
    'payslip.annualLeave': 'Annual Leave',
    'payslip.leaveDay': 'Leave Days',
    'payslip.absentDay': 'Absent Days',
    'payslip.bonus': 'Bonus',
    'payslip.deduction': 'Deduction',
    'payslip.netIncome': 'Net Income',
    'payslip.personalTax': 'Personal Income Tax',
    'payslip.export': 'Export Payslip',
    'payslip.approve': 'Approve Payroll',
    'payslip.showSalary': 'Show Salary',
    'payslip.amercement': 'Amercement',
    'payslip.checkInLate': 'Check In Late',
    'payslip.requestDeclined': 'Request Declined',
    'payslip.otherAmercement': 'Other Amercement',
    'payslip.workingDayPlan': '(1) Working day plan',
    'payslip.paidWorkingDay': '(2) Paid working day',
    'payslip.actualWorkingDay': '(2.1) Actual working day',
    'payslip.paidLeaveDay': '(2.2) Paid leave',
    'payslip.unpaidLeaveDay': '(2.3) Unpaid leave',
    'payslip.annualLeaveDay': '(2.4) Annual leave',
    'payslip.remainAnnualLeaves': '(3) Remain Annual Leaves',
    'payslip.earnings': 'A. Earnings',
    'payslip.baseSalary': 'Base Salary',
    'payslip.paidWorkingDayLabel': 'Paid working day',
    'payslip.actualSalary': 'Actual Salary',
    'payslip.deductions': 'B. Deductions',
    'payslip.socialInsurance': 'Social Insurance (8%)',
    'payslip.healthInsurance': 'Health Insurance (1.5%)',
    'payslip.unemploymentInsurance': 'Unemployment Insurance (1%)',
    'payslip.personalIncomeTax': 'Personal Income Tax',
    'payslip.otherDeduction': 'Other Deduction',
    'payslip.payableIncome': 'Payable Income',

    // Attendance
    'attendance.title': 'Attendance',
    'attendance.checkIn': 'Check In',
    'attendance.checkOut': 'Check Out',
    'attendance.workingHours': 'Working Hours',
    'attendance.late': 'Late',
    'attendance.forgot': 'Forgot Check In/Out',
    'attendance.ipClockIn': 'IP Clock In',
    'attendance.ipClockOut': 'IP Clock Out',
    'attendance.morningApp': 'Morning Application',
    'attendance.afternoonApp': 'Afternoon Application',

    // Leave
    'leave.title': 'Leave',
    'leave.type': 'Leave Type',
    'leave.startDate': 'Start Date',
    'leave.endDate': 'End Date',
    'leave.session': 'Session',
    'leave.reason': 'Reason',
    'leave.status': 'Status',
    'leave.pending': 'Pending',
    'leave.approved': 'Approved',
    'leave.rejected': 'Rejected',
    'leave.requestsTitle': 'Leave Requests',
    'leave.createRequest': 'Create Request',
    'leave.deleteRequest': 'Delete Request',
    'leave.updateRequest': 'Update Leave Request',
    'leave.createLeaveRequest': 'Create Leave Request',
    'leave.deleteConfirm': 'Do you want to delete this leave request?',
    'leave.morningApplication': 'Morning Application',
    'leave.afternoonApplication': 'Afternoon Application',
    'leave.fullDayApplication': 'Full Day Application',
    'leave.daysApplication': 'Days',
    'leave.showDetail': 'Show Detail',
    'leave.requestingRemaining': 'Requesting / Remaining',
    'leave.days': 'days',
    'leave.casualLeave': 'Casual Leave',
    'leave.sickLeave': 'Sick Leave',
    'leave.annualLeave': 'Annual Leave',
    'leave.forgotCheckInOut': 'Forgot Check In/Out',
    'leave.comeLateLeaveEarly': 'Come Late/Leave Early',
    'leave.workFromHome': 'Work From Home',
    'leave.multiDays': 'Multi Days',
    'leave.end': 'End',
    'leave.validationStartEmpty': 'Start day can not be empty!',
    'leave.validationEndEmpty': 'End day can not be empty!',
    'leave.validationReasonEmpty': 'Reason can not be empty!',
    'leave.validationAnnualNotEnough': 'Annual leave is not enough!',

    // Overtime
    'overtime.title': 'Overtime',
    'overtime.hours': 'Hours',
    'overtime.type': 'Type',
    'overtime.weekday': 'Weekday',
    'overtime.weekend': 'Weekend',
    'overtime.holiday': 'Holiday',
    'overtime.otRequests': 'OT Requests',
    'overtime.createRequest': 'Create OT Request',
    'overtime.deleteRequest': 'Delete OT Request',
    'overtime.deleteConfirm': 'Do you want to delete this request?',
    'overtime.multiplier': 'Multiplier',
    'overtime.time': 'Time',

    // Amercement
    'amercement.title': 'Amercement',
    'amercement.reason': 'Reason',
    'amercement.amount': 'Amount',
    'amercement.checkInLate': 'Check In Late',
    'amercement.forgotCheckOut': 'Forgot Check Out',
    'amercement.absent': 'Absent',
    'amercement.totalAmercement': 'Total Amercement',
    'amercement.forgotCheckInOutEarly': 'Forgot/Early Leave',
    'amercement.times': 'times',
    'amercement.absentForgotHeader': 'Absent/Forgot Check In/Out/Early',

    // Personal tax
    'tax.taxableIncome': 'Taxable Income',
    'tax.selfDeduction': 'Self Deduction',
    'tax.dependentDeduction': 'Dependent Deduction x',
    'tax.netTaxableIncome': 'Net Taxable Income',
    'tax.upTo': 'Up to',

    // Installment
    'installment.title': 'Installment',
    'installment.amount': 'Amount',
    'installment.remaining': 'Remaining',
    'installment.start': 'Start',
    'installment.end': 'End',
    'installment.thisMonth': 'This month',

    // Overtime
    'overtime.cardTitle': 'Overtime',
    'overtime.create': 'Create',
    'overtime.showDetail': 'Show Detail',
    'overtime.updateRequest': 'Update OT Request',
    'overtime.date': 'Date',
    'overtime.otHour': 'OT Hour',
    'overtime.tasks': 'Tasks',
    'overtime.request': 'Request',
    'overtime.update': 'Update',
    'overtime.declined': 'Declined',
    'overtime.approved': 'Approved',
    'overtime.awaiting': 'Awaiting',

    // Bank
    'bank.bankName': 'Bank Name',
    'bank.bankAccount': 'Bank Account',

    // Payroll history table headers
    'payrollHistory.date': 'Date',
    'payrollHistory.salary': 'Salary',
    'payrollHistory.bonus': 'Bonus',
    'payrollHistory.employeeType': 'Employee Type',
    'payrollHistory.annualLeaves': 'Annual Leaves',
    'payrollHistory.description': 'Description',
    'payrollHistory.applyDate': 'Apply Date',

    // Validation messages
    'validation.dateEmpty': 'Date can not be empty!',
    'validation.reasonEmpty': 'Reason can not be empty!',

    // Home
    'home.happyLunch': 'Happy Lunch',
    'home.happyWorking': 'Happy Working Day',
    'home.outsideWorkingHours': 'Outside of working hours',
    'home.outsideOffice': 'Outside the Office',
    'home.tooEarlyCheckin': 'It\'s too early to check in!',
    'home.connectNetwork': 'Connect to company network first!',
    'home.checkIn': 'Check In',
    'home.checkOut': 'Check Out',
    'home.thankyou': 'Thank you',
    'home.confirmCheckoutTitle': 'Check Out',
    'home.confirmCheckoutBody': 'Are you sure you want to check out?',
    'home.contactAdmin': 'Contact admin!',
    'home.oops': 'Oops...',

    // Home - attendance summary
    'home.avgClockIn': 'Avg Clock In',
    'home.avgClockOut': 'Avg Clock Out',
    'home.avgWorkingHr': 'Avg Working Hr',
    'home.absentLeaves': 'Absent / Leaves',
    'home.absent': 'Absent',
    'home.doNothingChill': 'Do nothing and Chill',
    'home.workingHrs': 'Working Hr\'s',
    'home.morning': 'Morning',
    'home.afternoon': 'Afternoon',
    'home.fullDay': 'Full Day',
    'home.days': 'Days',
    'home.statusDeclined': 'Declined',
    'home.statusApproved': 'Approved',
    'home.statusAwaiting': 'Awaiting',
    'home.by': 'by',
    'home.approveBtn': 'Approve',
    'home.declineBtn': 'Decline',
    'home.hr': 'hr',
    'home.ongoingEventsTitle': 'Upcoming Events',
    'home.noOngoingEvents': 'No upcoming events right now.',
    'home.todayIsYourBirthday': 'Today is your birthday. Happy Birthday!',
    'home.countdownToday': 'Today',
    'home.countdownTomorrow': 'Tomorrow',
    'home.countdownInDays': 'In {days} days',
    'home.daysWithCompany': 'We\'ve been together for',
    'home.daysUnit': 'days',
    'home.yearsUnit': 'year',
    'home.monthsUnit': 'month',
    'home.daysShortUnit': 'day',

    // Weather
    'weather.forecastTitle': 'Weather Forecast',
    'weather.unavailable': 'Weather data is unavailable.',
    'weather.sunny': 'Sunny',
    'weather.partlyCloudy': 'Partly Cloudy',
    'weather.cloudy': 'Cloudy',
    'weather.fog': 'Fog',
    'weather.drizzle': 'Drizzle',
    'weather.rain': 'Rain',
    'weather.snow': 'Snow',
    'weather.shower': 'Shower',
    'weather.thunderstorm': 'Thunderstorm',
    'weather.unknown': 'Unknown',
    'weather.extremeHeatTitle': 'Extreme Heat Alert',
    'weather.extremeHeatMessage': 'The weather is very hot today. Please stay hydrated.',
    'weather.extremeColdTitle': 'Extreme Cold Alert',
    'weather.extremeColdMessage': 'The weather is very cold today. Please keep warm.',
};

export default en;
